/**
 * TimeLog API endpoints
 */
import axiosClient from './axiosClient';
import { TimeLog, TimeLogSummary } from '@/types';

interface CreateTimeLogData {
  task_id: number;
  hours_spent: number;
  date: string;
  description?: string;
}

interface TimeLogFilters {
  task_id?: number;
  user_id?: number;
  start_date?: string;
  end_date?: string;
  skip?: number;
  limit?: number;
}

export const timelogAPI = {
  /**
   * Get all time logs with filters
   */
  getTimeLogs: async (filters?: TimeLogFilters): Promise<TimeLog[]> => {
    const response = await axiosClient.get<TimeLog[]>('/timelogs', { params: filters });
    return response.data;
  },

  /**
   * Get time log by ID
   */
  getTimeLog: async (id: number): Promise<TimeLog> => {
    const response = await axiosClient.get<TimeLog>(`/timelogs/${id}`);
    return response.data;
  },

  /**
   * Create new time log
   */
  createTimeLog: async (data: CreateTimeLogData): Promise<TimeLog> => {
    const response = await axiosClient.post<TimeLog>('/timelogs', data);
    return response.data;
  },

  /**
   * Update time log
   */
  updateTimeLog: async (id: number, data: Partial<CreateTimeLogData>): Promise<TimeLog> => {
    const response = await axiosClient.put<TimeLog>(`/timelogs/${id}`, data);
    return response.data;
  },

  /**
   * Delete time log
   */
  deleteTimeLog: async (id: number): Promise<void> => {
    await axiosClient.delete(`/timelogs/${id}`);
  },

  /**
   * Get time summary for project
   */
  getProjectTimeSummary: async (
    projectId: string,
    startDate?: string,
    endDate?: string
  ): Promise<TimeLogSummary[]> => {
    const response = await axiosClient.get<TimeLogSummary[]>(
      `/worklogs/summary/project/${projectId}`,
      {
        params: { start_date: startDate, end_date: endDate },
      }
    );
    return response.data;
  },

  /**
   * Get time summary by project ID and optional date range
   */
  getSummary: async (filters?: {
    project_id?: string;
    start_date?: string;
    end_date?: string;
  }): Promise<TimeLogSummary[]> => {
    const response = await axiosClient.get<TimeLogSummary[]>(
      '/timelogs/summary',
      { params: filters }
    );
    return response.data;
  },
};


